module.exports = __webpack_public_path__ + "static/media/levigato.203df0e8.png";